import axios from 'axios';
import { getAccessToken } from '../../../../auth/oktaConfig';
import type { IBlock } from '../../../../store/senderBuild/types';
import { TEMPLATES_URL } from '../../../environment-config';
import { headers } from '../../common/helper';
import { graphQlRequest } from '../template-api';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const addBlock = async (templateId: string, documentId: string, block: IBlock) => {
  const accessToken = await getAccessToken();

  const blockWithValueCleanedUp = cleanBlockForAdd(block);
  const { data, status } = await axios.post(
    `${TEMPLATES_URL}/templates/${templateId}/documents/${documentId}/blocks`,
    blockWithValueCleanedUp,
    headers(accessToken)
  );
  return {
    result: data,
    status,
  };
};
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const cleanBlockForAdd = (block: IBlock) => {
  const strings = ['Signature', 'Initials', 'FullName', 'DateSigned', 'Strike', 'Rectangle'];
  if (strings.includes(block.blockType)) {
    const { value, ...blockWithoutValue } = block;
    return blockWithoutValue;
  }
  if (['Checkbox', 'ReadOnlyCheckbox'].includes(block.blockType)) {
    return { ...block, value: block.value === true };
  }
  return { ...block, value: block.value || '' };
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const editBlock = async (templateId: string, documentId: string, block: IBlock) => {
  const accessToken = await getAccessToken();
  const { status } = await axios.put(
    `${TEMPLATES_URL}/templates/${templateId}/documents/${documentId}/blocks/${block.blockId}`,
    block,
    headers(accessToken)
  );
  return status;
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const deleteBlocks = async (templateId: string, blockIds: string[]) => {
  await graphQlRequest(
    `
    mutation {
      deleteBlocks(templateId: "${templateId}", blockIds: ${JSON.stringify(blockIds)})
    }
  `
  );
};
